import { Component, DestroyRef, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RaceSessionService } from '../timing-tower/race-session.service';
import { ModalService } from '../lxp/modal.service';

@Component({
	selector: 'vb-lxp-race-control-marquee',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './vb-lxp-race-control-marquee.component.html',
	styleUrls: ['./vb-lxp-race-control-marquee.component.css'],
})
export class VbLxpRaceControlMarqueeComponent {
	public raceSessionService = inject(RaceSessionService);
	private readonly destroyRef = inject(DestroyRef);
	private readonly modalService = inject(ModalService);

	public raceControlCurrentMessages = this.raceSessionService.raceControlCurrentMessages;

	constructor() {
		this.raceSessionService.raceControl$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
	}

	public hasMessages = computed(() => this.raceControlCurrentMessages().length > 0);

	public marqueeDuration = computed(() => {
		const count = this.raceControlCurrentMessages().length;
		const seconds = Math.max(28, 28 + (count - 1) * 8);
		return `${seconds}s`;
	});

	public openRaceControlPanel() {
		this.modalService.openModal('race-control');
	}
}
